<template>
	<div id="dashboard-edit-account-subtemplate" v-if="userInfo">
		
		<label for="Full Name" class="col md-5">
			<p>Full Name</p>
			<input type="text" 
				@input="fullNameSplit" 
				ref="fullNameEle"
				:placeholder="userInfo.firstName + ' ' +userInfo.lastName" 
				>
		</label>
		<label class="col md-5 md-offset-2">
				<p>Company Name</p>
			<input type="text" :placeholder="userInfo.companyName" v-model="formData.companyName">
		</label>

		<label class="col md-5">
			<p>Address Line 1</p>
			<input type="text" :placeholder="userInfo.addressLineOne" v-model="formData.addressLineOne">
		</label>
		<label class="col md-5 md-offset-2">
			<p>Address Line 2</p>
			<input type="text" :placeholder="userInfo.addressLineTwo" v-model="formData.addressLineTwo">
		</label>

		<label class="col md-5">
			<p>Town/City</p>
			<input type="text" :placeholder="userInfo.city" v-model="formData.city">
		</label>
		<label class="col md-5 md-offset-2">
			<p>Postcode</p>
			<input type="text" :placeholder="userInfo.postCode" v-model="formData.postCode">
		</label>

		<label class="col md-5">
			<p>Telephone Number One</p>
			<input type="text" :placeholder="userInfo.phoneNumber" v-model="formData.phoneNumber">
		</label>
		<label class="col md-5 md-offset-2">
			<p>Telephone Number Two</p>
			<input type="text" :placeholder="userInfo.phoneNumberTwo" v-model="formData.phoneNumberTwo">
		</label>

		<div class="col">
		<button class="btn" @click="updateAccount" :disabled="disableUpdateBtn">Update Account</button>
		</div>

	</div>
</template>

<script>

// import CreateProgressBar from '../common/Create/CreateProgressBar';
// import LoginPanel from '../common/Login/LoginPanel';


export default {
	data(){
		return {
			formData : {
				email : "",
				firstName : "",
				lastName : "",
				companyName : "",
				addressLineOne : "",
				addressLineTwo : "",
				city : "",
				postCode : "",
				phoneNumber : "",
				phoneNumberTwo : "",
			}
		}
	},
	computed : {
		userInfo(){
			return this.$store.getters.getUserInfo
		},
		disableUpdateBtn(){
			let shouldUpdate = true;
			Object.keys(this.formData).forEach((key, i) => {
				if(this.formData[key]){
					shouldUpdate = false;
				}
			})
			return shouldUpdate;
		}
	},
	methods : {
		fullNameSplit(e){
			let fullName = e.target.value;
			fullName.trim()
			let split = fullName.split(" ");
			let firstName = split[0];
			let lastName = split[1];
			this.formData.firstName = firstName;
			this.formData.lastName = lastName || "";
			if(firstName && lastName){
				this.formData.alias = split[0] + ' ' + split[1];
			} else {
				this.formData.alias = "";
			}
			
		},
		updateAccount(){
			let message = "";
			let formData = this.formData;

			// ensure a first and last name is entered
			if(this.formData.firstName && !this.formData.lastName){message = "you must provide your last name. hint: add a space between your first and last name";}
			if(!this.formData.firstName && this.formData.lastName){message = "you must provide your last name. hint: add a space between your first and last name";}
			

			if(message.length){
				this.$toasted.error(message, {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 4000
                })
				return;
			}
			let fieldsToSend = {};

			Object.keys(this.formData).map((key, i) => {
				if(this.formData[key]){
					fieldsToSend[key] = this.formData[key]
				}
			})

			let dataToSend = {
				userId : this.userInfo._id,
				data : fieldsToSend
			}
			
	
			this.$store.dispatch('updateUserDetails', dataToSend)
			.then((response) => {

    			this.$toasted.clear();
    			if(response.confirmation === 'success'){
    				this.$toasted.success("Details Updated", {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
					})	
					this.formData = {
						email : "",
						firstName : "",
						lastName : "",
						companyName : "",
						addressLineOne : "",
						addressLineTwo : "",
						city : "",
						postCode : "",
						alias : "",
						phoneNumber : "",
						phoneNumberTwo : ""
					}
			
					this.$refs.fullNameEle.value = ""
    				return;
    			}
    			if(response.confirmation === 'validation'){
    				this.$toasted.error(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
    			} else {
    				this.$toasted.error(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
    			}
    		})
    		.catch((err) => {
				this.$toasted.clear();
				this.$toasted.error("something went wrong. " + err.message, {
		            theme: 'bubble',
		            position: 'bottom-center',
		            duration: 5000
		        })
    		})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DashboardEditAccount.vue